import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';

@Component({
    selector: 'app-login-landing',
    templateUrl: './login-landing.component.html',
    styleUrls: ['./login-landing.component.css'],
    standalone: false
})
export class LoginLandingComponent {
  @ViewChild('pricing') pricing;
  @ViewChild('professionpopup') professionpopup;
  showContent: boolean = false;
  dynamicClass: string = '';
  sourceFrom: boolean = false;
  constructor(public auth: AuthService, public modalService: NgbModal,private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.showContent = params['app'] === 'true';
      if(this.showContent) {
        this.dynamicClass = this.showContent ? 'ShowOne' : 'ShowTwo';
        this.sourceFrom = true;
      }
    });
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onClose() {
    this.modalService.dismissAll();
  }

  ContinueProfiessional(){   
    this.auth.login('authprofessional', this.sourceFrom);
  }
}
